import React from 'react'

import { sanitizeAndProcessHtml } from '@/_lib/dom-purify.utils'

export interface EmbedData {
	service: string
	source: string
	embed: string
	width: number
	height: number
	caption?: string | null
	/** HTML caption (e.g. from TipTap); rendered with sanitization when present */
	captionHtml?: string | null
}

export interface BEditorJsEmbedProps {
	data: EmbedData
}

const figcaptionContent = (data: EmbedData) => {
	const { caption, captionHtml } = data
	if (captionHtml && captionHtml.length > 0) {
		return (
			<figcaption
				className='max-w-[658px] mx-auto mt-4 text-sm text-[#4A337A] font-light [&_a]:text-purple-600 [&_a]:underline hover:[&_a]:text-purple-800'
				dangerouslySetInnerHTML={{ __html: sanitizeAndProcessHtml(captionHtml) }}
				suppressHydrationWarning
			/>
		)
	}
	if (caption && caption.length > 0) {
		return (
			<figcaption className='max-w-[658px] mx-auto mt-4 text-sm text-[#4A337A] font-light'>
				{caption}
			</figcaption>
		)
	}
	return null
}

export const BEditorJsEmbed: React.FC<BEditorJsEmbedProps> = ({ data }) => {
	const { service, embed, caption } = data

	const widthClass = 'max-w-[658px] mx-auto'

	if (service === 'youtube') {
		return (
			<figure className='my-14'>
				<div className={widthClass}>
					<div className='aspect-[658/403] rounded-[21px] overflow-hidden bg-[#DED3B9]'>
						<iframe
							src={embed}
							width='100%'
							height='100%'
							title={caption || 'YouTube video'}
							className='w-full h-full'
							allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
							allowFullScreen
							data-cookieyes='cookieyes-necessary'
						/>
					</div>
				</div>
				{figcaptionContent(data)}
			</figure>
		)
	} else if (service === 'spotify') {
		return (
			<figure className='my-14'>
				<div className={widthClass}>
					<div className=''>
						<iframe
							src={embed}
							width='100%'
							height={152}
							title={caption || 'Spotify playlist'}
							allow='autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture'
							allowFullScreen
							data-cookieyes='cookieyes-necessary'
						/>
					</div>
				</div>
				{figcaptionContent(data)}
			</figure>
		)
	} else {
		return null
	}
}

export default BEditorJsEmbed
